module.exports = __webpack_public_path__ + "media/images/crown-104aa9058d5f38ab1c9e3506d15db38a.png";